<template>
  <!-- Page Content -->
  <div class="container">
    <div class="row">
      <!-- Blog Entries Column -->
      <div class="col-md-8">
        <h1 class="my-4">Manage Blogs</h1>
        <small>Edit - Update - Delete</small>

        <!-- Blog Post -->
        <div class="card mb-4" v-for="blog in blogs" :key="blog.id">
          <div class="card-body">
            <h2 class="card-title">{{ blog.title }}</h2>

            <quill-editor
              ref="myQuillEditor"
              :disabled="true"
              :options="editorOption"
              v-model="blog.content"
            />

            <a href="#" class="btn btn-primary">Read More →</a>
          </div>
          <div class="card-footer text-muted">
            {{ blog.created_at }}
          </div>
        </div>
      </div>

      <!-- Sidebar Widgets Column -->
      <div class="col-md-4">
        <!-- Search Widget -->
        <div class="card my-4">
          <h5 class="card-header">Search</h5>
          <div class="card-body">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Search for..."
              />
              <span class="input-group-btn">
                <button class="btn btn-secondary" type="button">Go!</button>
              </span>
            </div>
          </div>
        </div>

        <!-- Categories Widget -->
        <div class="card my-4">
          <h5 class="card-header">Categories</h5>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6">
                <ul class="list-unstyled mb-0">
                  <li>
                    <a href="#">Web Design</a>
                  </li>
                  <li>
                    <a href="#">HTML</a>
                  </li>
                  <li>
                    <a href="#">Freebies</a>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6">
                <ul class="list-unstyled mb-0">
                  <li>
                    <a href="#">JavaScript</a>
                  </li>
                  <li>
                    <a href="#">CSS</a>
                  </li>
                  <li>
                    <a href="#">Tutorials</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Side Widget -->
        <div class="card my-4">
          <h5 class="card-header">Side Widget</h5>
          <div class="card-body">
            You can put anything you want inside of these side widgets. They are
            easy to use, and feature the new Bootstrap 4 card containers!
          </div>
        </div>
      </div>
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
export default {
  props: ["blogs"],

  data() {
    return {
      editorOption: {
        theme: "bubble"
      }
    };
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  }
};
</script>
